import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { ChartWithBackgroundOptions } from './chart-with-background';
import { visitsByHourOfDayDataToSeriesData } from '@configurations/campaignAnalytics/visitsByHourOfDayChart';

export const visitsByTimeOfDayChartData = (
  visitsByHourOfDay: CampaignAnalyticsReport['visitsByHourOfDay']
): ChartWithBackgroundOptions['chartData'] =>
  visitsByHourOfDay.visible
    ? visitsByHourOfDayDataToSeriesData(visitsByHourOfDay.data)
        .map(data => ({
          name: data.name,
          value: data.y,
        }))
        .toReversed()
    : [];
